module.exports = {
  title: '道琼斯黑名单查询系统',
  Welcome: 'welcome',
  Pleaseinputcontents: 'Please input contents',
  Exitfail: 'Exit fail',
  Loadfailure: 'Load failure',
  LastUpdateTime: 'Last update time',
  UTpromptcontent: 'Do you need to update? Update data requires a fee',
  cancel: 'Cancel',
  confirm: 'Confirm',
  close: 'Close',
  PleaseChoose: 'Please choose',
  MonitoringCycle: 'Monitoring cycle',
  ArgumentsCannotBeEmpty: 'Arguments Cannot Be Empty',
  MonitorHint: 'Monitoring company will be charged,if sure to continue?',
  success: 'Success',
  refresh: 'Refresh',
  layuiModeltitle: 'Hint information',
  layuiModelconfirm: 'confirm',
  login: 'Login',
  Regain: 'Regain',
  PersonalCenter: 'Personal',
  ReturnHomepage: 'Return Homepage',
  SignOut: ' Sign Out',
  titlename: 'E-Net Data Full Collection <br> Know Your Customer Intelligently',
  PRC: 'Company(PRC)',
  GlobalCheck: 'Global Check',
  NonPRC: 'Company(Non-PRC)',
  Advanced: 'Advanced',
  searchPlaceholder: 'Company Name/ Business Number',
  FEnterfullameEnterprise: 'Please enter the full name of the enterprise',
  ChooseCountryOfEnterprise: 'Country of Enterprise',
  PersonalORorganizationName: 'Please input personal or organization name',
  SpecificName: 'Please enter entity specific name',

  Age: 'Age',
  Gender: 'Gender',
  View: 'View',
  Former: 'Former',
  Later: 'Later',

  // pageFooter
  Contact: 'For more services and support, please contact us',
  Telephone: 'Telephone：0571-26695555 turn 7',
  QQ: 'QQ',

  loginKYC: ' 道琼斯黑名单查询系统 Login',
  ObtainCode: ' Obtain Code',
  telPlaceholder: 'Phone Number',
  VerificationCode: 'Verification Code',
  Password: 'Enter the password',
  PasswordAgain: 'Enter the password again',
  NewPassword: 'Enter the new password',
  NewPasswordAgain: 'Enter the new password again',
  ResetPassword: 'Reset Password',
  LoginByPassword: 'By Password',
  LoginByCode: 'By Code',
  SignIn: 'Sign In',
  SignUp: 'Sign Up',
  NotSame: 'Password inconsistency',
  Company: 'The company of affiliation',
  ImageStr: 'Enter the characters in the image',
  Refresh: 'image is not clear, click to refresh',
  SMS_Code: 'SMS Code',
  Voice_Code: 'Voice Code',
  RegainCode: 'You have verified the code over the maximum number of times,Please regain.',
  SearchResult: 'Search Result',
  LegalPerson: 'Legal Person',
  BusinessNumber: ' Business Number',
  PhoneOrCodeIsNull: 'Phone or code is null',
  PasswordOrCodeIsNull: 'Password or code is null',

  // 提示 tip
  TipPwdFormat: 'Non-numeric beginning, length 6~14, supports upper and lower case letters, Numbers, symbols',
  TipPwdFormatError: 'Please start with a non-numeric number and at least use a combination of letters and Numbers without space!',
  TipPhoneFormatError: 'Cell phone number is empty or illegal!',

  FormerName: 'Former Name',
  phone: 'Phone',
  Email: 'E-mail',
  Address: 'Address',
  CompanyMap: 'Company Map',
  MacroAttach: 'Macro Attach',
  CompanyMapExplain: 'Grasp company info',
  MacroAttachExplain: 'Grasp macro info',
  UpdatedTime: 'Updated Time',
  QueriedTimes: 'Queried Times',
  updataData: 'Refresh',
  Monitor: 'Monitor',
  ViewMonitor: 'View Monitor',
  ReportDownload: 'Report Download',
  WaitForProgram: 'Being developed,please wait.',
  UpdatedTimes: 'Updated Times',
  Update: 'Update',
  Thisupdate: ' This update',
  Basics: 'Basics',
  Risks: 'Risks',
  intellectualProperty: 'IP',
  publicSentiment: 'Public Sentiment',
  FinancialStatements: 'Finance',
  MacroEvent: 'Macro Event',
  opinionEvents: 'Opinion Events',

  LegalPersoninformation: 'Legal Person',
  CompanyInvestment: 'Company Investment',
  EquityStructure: 'Equity Structure',
  PersonalDiagramMap: 'Personal Diagram',
  Details: 'Details',
  ComingSoon: 'Coming Soon',

  //  股权穿透-证券信息
  SecurityInformation: 'Security Information',
  StockCode: 'Stock Code',
  StockAbbreviation: 'Stock Abbreviation',
  StockMarket: 'Stock Market',
  StockPlate: 'Stock Plate',
  ListingDate: 'Listing Date',
  StockValue: 'Stock Value',
  PERatio: 'Price Earnings Ratio',
  PBRatio: 'Price To Book Ratio',

  RegisteredInformation: 'Registered Information',
  RegisteredCapital: 'Registered Capital',
  RegisteredDate: 'Registered Date',
  UniformSocialCreditCode: 'Uniform Social Credit Code',
  ConfirmedDate: 'Confirmed Date',
  OperationPeriod: 'Operation Period',
  Domicile: 'Domicile',
  BusinessScope: 'Business Scope',

  Status: 'Status',
  TaxpayerIdentificationNumber: 'Taxpayer Identification Number',
  ConpanyType: 'Conpany Type',
  RegistrationAuthority: 'Registration Authority',

  Shareholders: 'Shareholders',
  Serial: 'Serial',
  ShareholderName: 'Shareholder Name',
  INSTO: 'INSTO',
  SubscribedCapital: 'Subscribed Capital(Ten THS)',
  CAT: 'CAT',
  SubscribedDate: 'Subscribed Date',
  Relation: 'Relation',

  NorelatedInformation: 'No related information',
  statusDetails: ' Details',

  MOLandCR: 'Main office listed on the industrial and commercial registration',
  BlackListFlag: 'BlackList Flag',

  MainOfficerInformation: 'Main Officer listed on the listing announcement',
  MOIPosition: 'Position',
  MOIPositionStartDate: 'Position Start Date',
  MOIPositionEndDate: 'Position End Date',
  MOIRelation: 'Relation',

  AlterationBusiness: 'Alteration of Business',
  Changedate: 'Change date',
  ChangeProject: 'Change project',
  BeforetheChange: 'Before the Change',
  AftertheChange: 'After the Change',

  Branch: 'Branch',

  ShareholdingStructure: 'Shareholding Structure',
  Shareholder: 'Shareholder',
  SuspectedBeneficiary: 'Suspected Beneficiary',
  Beneficiary: 'Beneficiary',
  Degree: 'Level',
  DefaultDegree: ' Default as 5',
  Tree: 'Tree',
  Form: ' Form',

  SSEnterpriseName: 'Enterprise Name',
  SSConpanyType: 'Conpany Type',
  Export: 'Export',
  SSShareholderlevel: 'Shareholder level',
  SSBusinessCode: 'Business Code',
  SSShareholder: 'Shareholder',
  SSShareholderType: 'Shareholder Type',
  SSLegalPerson: 'Legal Person',
  SSShareholderStatus: 'Shareholder Status',
  SSINSTO: 'INSTO',
  SSSubscribedCapital: 'Subscribed Capital',
  SSDeliveredCapital: 'Delivered Capital',
  SSSuperiorshareholdercode: 'Superior shareholder code',
  SSSuperiorInvestmentPath: 'Superior investment path',
  SSriskType: 'Risk Type',
  SShumanFigures: 'Human Figures',

  ControlPath: 'Control path',
  SSConpanyStatus: 'Conpany Status',
  SSOperationAbnormal: 'Is operation abnormal',

  AdvancedScreening: 'Advanced Screening',
  MassScreening: 'Mass Screening',

  PersonalPerson: 'Person',
  PersonalOrganization: 'Organization',
  BatchPersonalPerson: 'Person-Batch',
  BatchPersonalOrganization: 'Organization-Batch',
  PGlobalBlacklist: 'Blacklist',
  PCompanyInvestment: 'Co.INVEST',
  PExecutivesInvestment: 'Officer INVEST',
  PNaturePersonInvestment: 'Personal INVEST',
  CompanyNetwork: 'Company Network',
  PFormType: 'Type',
  PFormAll: 'All',
  PFormPerson: 'Person',
  PFormOrganization: 'Organization',
  PFormName: 'Name',
  PFormCName: 'Chinese Name',
  PFormNameInput: 'Please Enter the Full Name of the Person',
  PFormGender: 'Gender',
  PFormMale: 'Male',
  PFormFemale: 'Female',
  PFormUnknown: 'Unknown',
  PFormBirthday: 'Birthday',
  PFormNationality: 'Nationality',
  CertificateType: 'Type of certificate',
  CertificateCode: 'The certificate code',
  PFormCountryRegion: 'Country/Region',
  PFormzhushi: 'More detail entered results more precisely',
  PFormChecking: 'Checking',
  StartCheck: 'Start Check',

  // 个体、实体批量识别
  TaskName: 'Task Name',
  TaskStatus: 'Task Status',
  TotalCount: 'Total(count)',
  HitCount: 'Hit(count)',
  MissCount: 'Miss(count)',
  CreateTime: 'Create Time',
  UpdateTime: 'Update Time',
  Reset: 'Reset',
  Underway: 'Underway',
  Finished: 'Finished',
  TaskUnderway: 'Task Underway',
  TempletDownload: 'Download Templet',
  LimitTip: 'Only excel files and no more than 5M',
  Upload: 'Upload File',
  Add: 'Add',
  FirstTaskName: 'Enter taskname first',
  FirstUpload: 'Upload file first',
  Deleted: 'Delete successfully',
  ConfirmDelete: 'Are you sure you want to delete it ?',
  FirstSelect: 'Select task first',
  OnlySelectOne: 'Only Select One',
  EnterName: 'Please Enter Name',
  ChineseName: 'Chinese Name',

  EnterpriseInformation: 'Enterprise',
  EnterpriseInformationInput: 'Please Enter the Enterprise Name/Uniform Social Credit Code/Business Registration Number',
  EnterprisePersonName: 'Name',
  EnterprisePersonNameInput: 'Please Enter the Person Name at above Enterprise',

  IDCardNumber: 'ID Card Number',
  IDCardNumberInput: 'Please Enter the ID Card Number',

  worldcheckListTitle: 'Intelligent KYC Searching Result',
  worldcheckName: 'Name',
  worldcheckAlias: 'Alias',
  worldcheckGender: 'Gender',
  beforeMarriage: 'Before Marriage',
  worldcheckBirthday: 'Birthday',
  worldcheckNationality: 'Nationality',
  worldcheckCountryRegion: 'Country/Region',
  worldcheckSubCategory: 'Category',
  worldcheckCategory: 'Sub-Category',
  worldcheckMore: 'Another Blacklist',
  customerType: 'Type',
  ListClassification: 'List Classification',
  SecondClassification: 'Second Classification',
  ThirdClassification: 'Third Classification',
  registrationDate: 'Regist RationDate',
  IDNumber: 'ID Number',
  worldcheckDeceased: 'Deceased',
  worldcheckStatus: 'Status',
  audit: 'Audit',
  ifSureToAudit: 'Are you sure to modify the status of this stream record?',

  worldcheckBasicInformation: 'Basic Information',
  worldcheckAdditionInformation: 'Addition Information',
  worldcheckCauseBlacklist: 'Cause of Blacklist',
  worldcheckKeywords: 'Keywords',
  worldcheckClickDetails: 'Click for Details',
  worldcheckSocialNetworks: 'Social Networks',
  worldcheckIncidenceRelation: 'Incidence Relation',
  worldcheckOrganization: 'Organization',
  worldcheckIndividual: 'Individual',

  WCPersonDetails: 'Person Details',
  WCPosition: 'Position',
  WCGender: 'Gender',
  WCNationality: 'Nationality',
  WCRegistrationTIme: 'Registration TIme',
  WCTitle: 'Title',
  CountriesAndRegions: 'Countries',
  WCBirthday: 'Birthday',
  WCPlaceBirth: 'Place of Birth',
  WCUpdateTime: 'Update Time',
  WCAddressMapInfo: 'Address Info',
  WCAddressMap: 'map',
  WCAddressFrom: 'from',
  UserImage: 'Image URL',

  WCProfessionDetails: 'Details',
  WCProfessionType: 'Type',
  WCProfessionName: 'Name',
  WCProfessionStartData: 'StartData',
  WCProfessionEndData: 'EndData',

  PersonalNameType: 'Name Type',
  PersonalName: 'Name',
  PersonalLastName: 'Last Name',
  PersonalMiddleName: 'Middle Name',

  SanctionsListName: 'Sanctions Name',
  SanctionsStartData: 'Start Data',
  SanctionsStartData: 'End Data',

  WCKeywords: 'Keywords',
  WCDescriptions: 'Descriptions',
  WCIssueCountry: 'Country',
  City: 'City',
  Street: 'Street',
  AddressURL: 'Address URL',
  Confidence: 'Confidence',
  companyName: 'Name',
  AssociationRelationshipType: 'Relationship Type',
  AssociatedInstitutionName: 'Institution Name',
  AssociatedInstitutionPersonalName: 'Personal Name',
  CorrelationDescription: 'Correlation Description',
  WCSocialNetworkDiagram: 'Social Network Diagram',

  //  个人中心begin
  UserLevel: 'Level: Ordinary',
  PCMonitorEnterprise: 'Monitor-Enterprise',
  PCMonitorIndividual: 'Monitor-Individual',
  financialReport: 'Financial-Report',
  PCAll: 'All',
  PCClearAll: 'Clear All',
  MonitorList: 'Monitor List',
  MonitorResult: 'Monitor Result',
  ManualVerification: 'Manual Verification',
  ScreeningRecord: 'Screening Record',
  AppliedList: 'Applied List',
  StatementDetails: 'Statement Details',
  FavorList: 'Favor',
  QueryReport: 'Query Report',
  CompanyUnderMonitor: 'Company Under Monitor',
  MonitorStartDate: 'Start Date',
  MoniotrEndDate: 'End Date',
  MonitorStatus: 'Status',
  MonitoringFrequency: 'Monitoring Frequency(Day)',
  Day: 'Day',
  Renewal: 'Renewal',
  QSY: 'QSY(Day)',
  IndividualUnderMonitor: 'Individual Under Monitor',
  IndividualName: 'Individual Name',
  AppliedCompanyList: 'Applied Company List(Finance Statement)',
  MoreFinanceStatement: 'More Finance Statement',
  ApplyStatus: 'Status',
  ListedStatus: 'Listed or not',
  List: 'Listed',
  Unlisted: 'Unlisted',
  FinancialDataDate: 'Update Date',
  ApplyNewFinance: 'Apply New Finance Statement',
  InputNotNull: 'The enterprise name cannot be empty.',
  FinanceStatementDetails: 'Finance Statement Details',
  PublicSentimentList: 'Public Sentiment(Favor List)',
  SentimentTitle: 'Title',
  AdditionDate: 'Addition Date',
  InfoSource: 'Source',
  Delete: 'Delete',
  NoCollectioninformation: 'No Collection Information',
  //  个人中心end

  pLeaglPersonINVEST: 'Leagl Person INVEST',
  PLeaglPersonServe: 'Leagl Person Serve',
  PCoINVEST: 'Co.INVEST',
  POPAbnormal: 'OP.Abnormal',
  PADMPenalty: 'ADM Penalty',
  PEquityPledge: 'Equity Pledge',
  PBranch: 'Branch',
  PEquityFrozen: 'Equity Frozen',
  PAlteration: 'Alteration',
  PLegalRIsk: 'Legal RIsk',

  PCMCategory: 'Category',
  PCMECN: 'ECN',
  PCMissueDate: 'Issue Date',
  PCMStatus: 'Status',

  PPPosition: 'Executives',
  PPLegalPerson: 'Legal Person',
  PPShareholder: 'Shareholder',
  PPLegalRisk: 'Legal Risk',

  PUnaudited: 'Unaudited',
  PBlacklist: 'My Client',
  PNonBlacklist: 'Not My Client',
  Recheck: 'Recheck',
  RecheckPass: 'Recheck-Pass',
  RecheckNotPass: 'Recheck-Not Pass',
  RecheckResult: 'Recheck Result',
  RecheckPeople: 'Recheck People',
  RecheckTime: 'Recheck Time',
  Pass: 'Pass',
  NotPass: 'Not Pass',
  ExportPDF: 'Export PDF',
  AddRemark: 'Add Remarks',
  InputRemark: 'Please Enter Remarks',
  RemarkMessage:'Remark Message',
  Submit: 'Submit',
  RemarkIsNotNull:'Remark Is Not Null!',
  PSequence: 'Sequence',
  PQueriedDate: 'Queried Date',
  PNationality: 'Nationality',
  PCountryRegion: 'Country/Region',
  PAuditStatus: 'Audit Status',
  PAuditPersonal: 'PAudit Personal',
  PAuditType: 'Audit Type',

  PAddMonitor: 'Add Monitor',

  PersonalDiagram: 'Personal Diagram',

  CompanyInvestmentDiagram: 'Company Investment Diagram',
  CIDCompany: 'Company',
  CIDLegalPerson: 'Legal Person',
  CIDUniformSocialCreditCode: 'Uniform Social Credit Code',
  InstitutionRegistNum: 'Institution registration number',
  CIDBusinessCode: 'Business Code',
  CIDStatus: 'Status',
  directOrIndirectHolds: ' directly or indirectly holds',
  NotBenificialNoPath: 'The shareholder is not the beneficial owner or actual controller,the investment control path will not be showed',

  ModelEnterpriseInformation: 'Enterprise Information',
  ModelSubscribedCapital: 'Subscribed Capital (Ten THS)',
  ModelINSTO: 'INSTO',

  naturaPersonalDiagram: 'Personal Diagram',

  companyCenterplaceholder: 'Please enter the name of monitoring enterprise',
  CompanyNameplaceholder: 'Please enter enterprise name',
  NaturalNameplaceholder: 'Please input natural person\'s name',
  EnterpriseAssociateplaceholder: 'Please enter the name of the enterprise associate',
  UserNameplaceholder: 'Please enter the detailed name of the user or entity',
  financialMonitorPlaceholder: 'Please enter the enterprise\'s name you have applied ',

  NewMonitor: 'New Monitor',
  //  财务报表
  Units: 'Unit:  RMB',
  BusiIncome: 'Business Income',
  BusiProfit: 'Business Profit',
  AccountReceivable: 'Account Receivable',
  TotalProfit: 'Total Profit',
  TotalLiablity: 'Total Liability',
  NetProfitsExcludePL: 'Net Profits Excluding P&L ',
  TotalCurrentLiability: 'Total Current Liability',
  NetProfitsDeductingPL: 'Net Profits Deducting Abnormal P&L',
  TotalNCurrentLiablities: 'Total Non-Current Liabilities',
  IncomeTax: 'Income Tax',
  TaxPayable: 'Tax Payable',

  ExcessiveRiskShareholder: 'Excessive risk shareholder',

  //  面包屑导航',
  Home: 'Home',
  FuzzySearch: 'Enterprise Fuzzy Search',
  StockDetail: 'Stock Detail',
  WorldCheckFuzzySearch: 'Global Check',
  WCBasicInfo: 'Global-Check Basic Info',
  WCMoreInfo: 'Global-Check More Information',
  RiskReason: 'Risk Reason',
  BenefitMap: 'Beneficiary Diagram',
  AbroadFuzzySearch: 'Abroad Fuzzy Search',
  AbroadStockDetail: 'Abroad Stock Detail',
  //  综合风险begin
  WaitPersonalRisk: 'Personal risk will be opened later, please look forward to it.',
  Click: 'Click',
  //  银保/证监会处罚弹窗',
  IRCPunishment: 'IRC Punishment',
  penaltyDecisionNumber: 'Document Number',
  penalInstrumentTitle: 'Document Title',
  penalInstrumentName: 'Document Name',
  PunishmentAgency: 'Punishment Organ',
  PublishedDate: 'Published Date',

  Party: 'Party',
  Object: 'Object',
  PunishClass: 'Punish Class',
  Fine: 'Fine(RMB)',
  PnealtyGround: 'Pnealty Ground',
  PenaltyAbstract: 'Penalty Abstract',
  PenaltyDetail: 'Penalty Detail',
  SourceLink: 'Source Link',
  Source: 'Source',
  Operator: 'Operator',
  WhetherToHit: 'Whether To Hit',

  //  工商行政处罚
  IndustryCommercePunish: 'IC Bureau Punishment',
  IllegalTypes: 'Illegal CAT',
  PunishmentTypes: 'Penalty Type',
  DecideDate: 'Decision Date',
  NoRelatedContent: 'no related content',

  //  开庭&立案信息
  FileInfo: 'Case Info',
  sessionInfo: 'Court Announcement',
  CaseNumber: 'Case Number',
  Plaintiff: 'Plaintiff',
  Defendant: 'Defendant',

  //  裁判文书
  Trial: 'Trial',
  DocumentNumber: 'Document Number',
  CaseType: 'Case Type',
  CaseContent: 'Case Content',
  ObjectionContent: 'Objection Content',
  ObjectionTime: 'Objection Time',

  //  经营异常',
  Exception: 'Exception',
  IncludeDate: 'Include Date',
  DecisionAuthority: 'Decision Authority(Inclued)',
  RemoveDate: 'Remove Date',
  RemoveAuthority: 'Decision Authority(Remove)',
  ExceptionReason: 'Exception Reason(Include)',
  RemoveReason: 'Exception Reason(Remove)',

  //  股权冻结
  FrozenNumber: 'Document Number',
  FrozenBalance: 'Frozen Balance',
  PenaltyAuthority: 'Penalty Authority',
  FrozenStartDate: 'Start Date',
  FrozenEndDate: 'End Date',
  StockUnfrozen: 'Stock Unfrozen',
  UnfrozenNumber: 'Document Number',
  PunishAuthority: 'Punish Authority',
  UnfrozenDate: 'Unfrozen Date',
  UnfrozenContent: 'Content',

  AdministrativePenalty: 'Administrative Penalty',
  PunishmentDate: 'Punishment Date',
  DecisionNumber: 'Decision Number',
  PunishmentContent: 'Punishment Content',
  Operation: 'Operation',
  Edit: 'Edit',

  Judicial: 'Judicial',
  JudicialCase: 'Case Title',
  JudicialDateIssue: 'Date of Issue',
  JudicialCaseNumber: 'Case Number',
  JudicialStatus: 'Status',
  JudicialPersonbeExecued: 'Person be Execued',
  JudicialExecutiveCourt: 'Executive Court',
  JudicialOperation: 'Operation',

  EquityPledge: 'Stock Impawn',
  EPRegistrationNumber: 'Registration Number',
  EPMortgagor: 'Pledgor',
  EPPawnee: 'Pledgee',
  EPPledgeAmount: 'Pledge Amount',
  EPDateRegistration: 'Registration Date',
  EPStatus: 'Status',
  PledgorBalance: 'Pledgor Balance',
  StockPawnAlter: 'Stock Pawn Alter',
  StockPawnCancellation: 'Stock Pawn Cancellation',
  PublishmentContent: 'Publishment Content',

  //  动产抵押
  ChattelMortgage: 'Chattel Mortgage',
  CMRegistrationNumber: 'Registration Number',
  CMMortgagee: 'Mortgageper List',
  Pawn: 'Pawn',
  CMMortgages: 'Mortgagepawn',
  CMOwnership: 'Ownership',
  PawnInfo: 'Pawn Info',
  CMAuthority: 'Registration Authority',
  CMStatus: 'Status',
  ClaimAmount: 'Claim Amount',
  PublicDate: 'Published Date',
  MortgageregList: 'Mortgagereg List',
  BoneType: 'Bone Type',
  Scope: 'Scope',
  BeginDate: 'Begin Date',
  EndDate: 'End Date',
  Mortgageper: 'Mortgageper',
  IDKind: 'ID Kind',
  IDNumber: 'ID Number',
  Remark: 'Remarks',
  MortgageAlter: 'Mortgage Alter',
  AlterDate: 'Alter Date',
  AlterContent: 'Alter Content',
  MortgageCancellation: 'Mortgage Cancellation',
  CancellationDate: 'Cancellation Date',
  CancellationReason: 'Cancellation Reason',

  IntellectualPropertyPledge: 'Intellectual Property Pledge',
  IPPRegistrationNumber: 'Registration Number',
  IPPProperty: 'Property',
  IPPMortgagor: 'Mortgagor',
  IPPPawnee: 'Pawnee',
  IPPDateRegistration: 'Date of Registration',
  IPPStatus: 'Status',

  //  严重违法失信
  Discredit: 'Discredit',
  IncludeDocumentNumber: 'Document Number(Include)',
  RemoveDocumentNumber: 'Document Number(Remove)',
  IllegalAndDiscreditEnterprise: 'Illegal and Discredit Enterpris',
  IADECategory: 'Category',
  IADEAuthority: 'Authority (Add)',
  IADEAuthorityRemove: 'Authority (Remove)',
  IADEDateAdded: 'Include Date',
  IADEDateRemoved: 'Remove Date',
  Cause: 'Cause',

  DDishonestCivilDebtor: 'Dishonest civil debtor',
  ExecutionCaseNumber: 'Execution case number',
  DExecutionBasisNumber: 'Execution basis number',
  DExecutionBasisUnit: 'Execution basis Unit',
  DDishonestyTime: 'Dishonesty time',
  ReleaseTime: 'Release time',

  RestrictingHighConsumption: 'Restricting high consumption executors',
  Name: 'Full Name',
  ExecutiveCourt: 'Executive court',
  CauseOfAction: 'Cause of action',
  filingTime: 'Filing time',

  RestrictingExitExecutors: 'Restricting Exit Executors',
  ReferenceNumber: 'Reference Number',
  BorderControlDate: 'Border Control Date',
  OccurrenceTime: 'Occurrence Time',
  BorderControlMeasures: 'Border Control Measures',

  DeadbeatInfor: 'Deadbeat Information',
  PublishedTime: 'Published Time',

  //  税务违法
  TaxIllegalInformation: 'Tax Violation',
  ClientName: 'Client Name',
  CompetentTaxAuthorities: 'Tax Authority',
  InspectionInstrumentsNumber: 'Document Number',
  TreatDecisiondate: 'Penalty Date',
  LimitedFulfilmentDate: 'Limited Fulfilment Date',
  PerformDate: 'Perform Date',
  TaxpayerStatus: 'Status',
  IllegalType: 'Illegal Type',
  OtherDetails: 'Details',
  IllegalMethod: 'Type',
  TaxPaid: 'Tax Paid',
  TaxUnpaid: 'Tax Unpaid',
  Penalty: 'Penalty',
  ActualPerformDate: 'Perform Date',
  //  综合风险end

  //  企业舆情
  PublicStatement: 'Public Statement',
  ReportManager: 'Report Manager',
  Favorite: 'Favorite',
  cancelCollect: 'Cancel',
  collectSuccess: 'Collect Success',
  cancelSuccess: 'Cancel Success',
  Share: 'Share',
  Present: 'Present',
  SevenDay: 'Seven',
  Month: 'Month',
  ThreeMonth: 'Three Month',
  HalfYear: 'Half A Year',
  Total: 'Total',
  ChooseType: 'Choose Type',
  ChoosePositive: 'Positive',
  ChooseNegative: 'Negative',
  ChooseNeutral: 'Neutral',
  PleaseChooseDateScope: 'Please select time horizon',
  PleaseChooseKeyEvents: 'Please select keywords',
  NoResultMatch: 'No results match',
  Time: 'Time',
  Condition: 'Condition',
  OR: 'OR',
  Search: 'Search',
  Clear: 'Clear',
  tooLongTimeSpan: 'The time span should not exceed 365 days',

  //  财务报表begin ',
  WaitSubscribedReportHint: 'You hava subscribed the report,please wait patiently.',
  UpdateFinancialData: 'Update Financial Data',
  BalanceSheet: 'Balance Sheet',
  CurrentAssets: 'Current Assets',
  Currency: 'Currency',
  NetAccountReceivable: 'Net Account Receivable',
  NetDeposit: 'Net Deposit',
  TotoalCurrentAssets: 'Totoal Current Assets',
  LongTermInvestment: 'Long Term Investment',
  LongTermEquityInvestment: 'Long Term Equity Investment',
  FixedAssets: 'Fixed Assets',
  OriginalValue: 'Original Value',
  LessAccumulatedDepreciation: 'Less: Accumulated Depreciation',
  NetFixedAssets: 'Net Fixed Assets',
  TotalFixedAssets: 'Total Fixed Assets',
  InvisibleDeferredAssets: 'Invisible & Deferred Assets',
  LongtermPrepaidExpenses: 'Long-term Prepaid Expenses',
  IntangiblesOtherAssets: 'Intangibles & Other Assets',
  TotalAssets: 'Total Assets',
  CurrentLiabilities: 'Current Liabilities',
  ShorttermBorrowings: 'Short-term Borrowings',
  NotesPayable: 'Notes Payable',
  AccountsPayable: 'Accounts Payable',
  TaxesPayable: 'Taxes Payable',
  TotalCurrentLiabilities: 'Total Current Liabilities',
  LongtermLiabilities: 'Long-term Liabilities',
  LongtermPayable: 'Long-term Payable',
  TotalLiabilities: 'Total Liabilities',
  StockholdersEquity: 'Equity',
  NetPaidCapital: 'Net Paid-in Capital',
  Undistributedprofits: 'Undistributed profits',
  TotalOwenerEquity: 'Total Owener\'s Equity  ',
  TotalLiabilitiesEquity: 'Total Liabilities & Owners’ Equity',

  IncomeStatement: 'Income Statement',
  RevenuefromMainOperation: 'Revenue from Main Operation',
  NetSales: 'Net Sales',
  LessOperationExpense: 'Less: Operation Expense',
  LessMainOperationCost: 'Less: Cost of Main Operation',
  SalesTax: 'Sales Tax',
  OperationCosts: 'Operation Costs',
  GAExpense: 'G&A Expense',
  FinanceExpense: 'Finance Expense',
  ProfitfromOperation: 'Profit from Operation',
  ProfitbeforeTax: 'Profit before Tax',
  LessIncomeTax: 'Less: Income Tax',
  NetProfit: 'Net Profit',
  TotalCompositeIncome: 'Total Composite Income',
  SubscribeFinancialHint: 'Requestion of unlisted company\'s  financial report will cause a cost and need 3 working days to process.Will You Continue to Sumbiit?',
  Sumbit: 'Sumbit',
  //  财务报表end

  //  知识产权begin
  SummaryStatistics: 'Summary Statistics',
  Patent: 'Patent',
  Trademark: 'Trademark',
  Copyright: 'Copyright',
  SummaryDetails: 'Details',
  PatentNumber: 'Patent Number',
  PatentName: 'Patent Name',
  IPCAT: 'CAT',
  ApplicationDate: 'Application Date',
  RegistrationNumber: 'Registration Number',
  RegistrationName: 'Registration Name',
  CheckinNumber: 'Registration Number',
  CopyrightName: 'Copyright Name',
  Inventor: 'Inventor',
  LegalStatus: 'Legal Status',
  Applicant: 'Applicant',
  Agency: 'Agency',
  PatentCAT: 'CAT',
  PatentStatus: 'Patent Status',
  ApplyNumber: 'Registration Number',
  OpenNumber: 'Patent Number',
  PublishmentDate: 'Publishment Date',
  Summary: 'Summary',
  Inset: 'Inset',
  TrademarkInfo: 'Trademark Info',
  TrademarkStatus: 'Trademark Status',
  ProductOrService: 'Product/Service/Project',
  Term: 'Term',
  TrademarkImage: 'Trademark Image',
  TrademarkType: 'Type',
  to: 'to',
  Abbr: 'Abbr',
  Version: 'Version',
  Owner: 'Owner',
  CopyrightType: 'Type',
  FinishDate: 'Finish Date',
  //  知识产权end

  //  图谱弹窗begin
  GeneralInformation: 'General Information',
  //  图谱弹窗end'

  // 个人监控列表and企业监控列表
  normal: 'normal',
  Expired: 'Expired',
  // end
  // 境外企业首页 begin
  // 证券信息',
  StockExchange: 'Stock exchange',
  CountryOfExchange: 'Country of exchange',
  IsTheMostImportantExchange: 'Is the most important exchange',
  // 基本信息',
  IDType: 'ID type',
  RegistrationDate: 'Registration date ',
  ApprovalDate: 'Approval date',
  RegistrationForm: 'Registration form',
  RegisteredAddress: 'Registered address',
  NumberOfStaff: 'Number of staff',
  Trade: 'Trade',
  AffiliatingArea: 'Affiliating area',
  Postcode: 'Postcode',
  Facsimile: 'Facsimile',
  URL: 'URL',
  WhetherImportersOrExporters: 'Whether importers or exporters',
  // 高管信息',
  ExecutivesInfo: 'Executives info',
  // 股东信息',
  IsBeneficiary: 'Is beneficiary',
  fivePerDataOnly: 'Only great than or equal to 5% data will be displayed on listed company.',
  // 财务信息',
  FinancialInfor: 'Financial information',
  ReportingDeadline: 'Reporting deadline',
  ReportingCycle: 'Reporting cycle',
  PropertyScope: 'Property scope',
  DataDetail: 'Data detail',
  MonetaryUnit: 'Monetary unit',
  // 境外企业首页 end

  // 企业数据批量处理 start
  DataBatchProcess: 'Data batch process',
  ListCleaning: 'Business list cleaning',
  BatchDownload: 'Batch download',

  // 名单管理 start
  ListManagement: 'List Management',
  ListUpdateOverview: 'List Update Overview',
  timesUpdatedToday: 'Record/times Updated Today',
  timesUpdatedThisMonth: 'Records/times Updated This Month',
  timesUpdatedTotal: 'Records/times Updated Total',
  ListDownload: 'List Download',
  UpdateTime: 'UpdateTime',
  Search: 'Search',
  Reset: 'Reset',
  FileName: 'File Name',
  UpdateRecord: 'Update Record',
  Operate: 'Operate',
  Operator: 'Operator',
  SoFar: 'So Far',
  Download: 'Download',
  YearMonthDay: 'Year/Month/Day',  //待确认

  // 黑名单详情-新闻来源
  NewsList: 'News List',
  No: 'No',
  LinkAddress: 'Link Address',
  Mark: 'Mark',
  Select: 'Select',
  ValidLink: 'Valid Link',
  InvalidLink: 'Invalid Link',
  LowAliasName: 'Low Alias Name',
  AlternativeName: 'Alternative Name',
  lowAliasName: 'Low Alias Name',
  alternativeName: 'Alternative Name',
  personage: 'person',
  organization: 'entity',
  yes: 'yes',
  no: 'no',
  mainData: 'Main Data',
  Sizer: 'Sizer',
  chooseTaskName: 'Choose Task Name',
  chooseAuditStatus: 'Audit Status',
  chooseUpdateTime: 'Update Time',
  addTaskSuccess: 'Add Task Success',
  postfix: 'postfix',
  registDate: 'Regist Date',
  Last24Hours: 'last 24 hours',
  LastOneWeek: 'last one week',
  LastOneMonth: 'last one month',
  SelectTheDataToExport: 'Select The Data To Export',
  ServerException: 'Server Exception',
  SetPassword: 'Please Set Your Password',
  PasswordNotNull: 'Password Is Not Null',
  PasswordError: 'Password must be 6-16 bits, alphanumeric or symbolic, special symbol (! $ # @ _)',
  HindMessage: 'Password must be 6-16 bits, alphanumeric or symbolic, special symbol (! $ # @ _)',
  ReportStatus: 'Report Status',
  ReportType: 'Report Type',
  ok: 'ok',
  ok1: 'ok',
  IsReportDelete: 'The due Diligence report cannot be recovered after deletion. Please confirm whether deletion is possible?',
  ReportConpony: 'The due Diligence report is being generated. You can check it out in the Personal Center - Report Management module',
  ReportDelete: 'Report Delete',
  DocPass: 'Doc Password',
  LookPass: 'Password Look',
  DownFiled: 'This function needs to be paid. If you want to open it, please contact GTN customer service',
  SerialNoList: 'SerialNo List',
  RecordCount: 'Record Count',
  OperateTime: 'Operate Time',
  RollID: 'Roll ID',
  InputSerialNo: 'Please enter the running number you want to check',
  UpdataSuccess: 'Updata Success'
}



// WEBPACK FOOTER //
// ./src/assets/i18n/en.js